import loadable from "utils/loadable";

export const HalamanUploadArticles = loadable(() => import("./index"));
export const PopupData = loadable(() => import("./PopupData"));
